// External libraries
import * as React from "react";
import { useLocalization } from "@shared-ui/localization-context";

// UITK
import { UitkCheckbox } from "uitk-react-switch";

// Utils
import { locKeys } from "./l10n";

// Types
import { WizardHotelPWAFlexComponent } from "../typings";

interface AddFlightProps {
  flexComponent: WizardHotelPWAFlexComponent;
  isFlightAdded: boolean;
  changeFormProperties: (event: React.ChangeEvent<HTMLFormElement>) => void;
  disablePackageOptions?: boolean;
}

export const AddFlight: React.FC<AddFlightProps> = ({
  flexComponent,
  changeFormProperties,
  isFlightAdded,
  disablePackageOptions,
}) => {
  if (!flexComponent.model.enableAddFlight) {
    return null;
  }

  const { formatText } = useLocalization();

  return (
    <div className="packageCheckbox all-r-padding-three">
      <UitkCheckbox
        id="addFlight"
        label={formatText(locKeys.addFlightLabel)}
        checked={isFlightAdded}
        onChange={changeFormProperties}
        disabled={disablePackageOptions}
      />
    </div>
  );
};

AddFlight.displayName = "AddFlight";
